export default __webpack_public_path__ + "static/media/Prev.873e58c1.png";